<div class="container-fluid px-0" style="background-image: url('assets/images/Vector.png'); min-height: 100vh;background-color: rgba(35, 113, 211, 0.03);">
    <div class="heading-top bg-white d-flex">
        <div class="h6 font-weight-bold pt-1 sm-22">
           <i class="fas fa-university px-2 primary-text"></i>
            Upgrade limits
        </div>
    </div>

    <!-- <div class="col-12 col-md-8 border border-danger m-2"> -->
    <div  class="col-sm-10 col-md-8 mt-2 p-0 pt-2 ml-md-5">
        <!-- <button class="btn btn-outline-primary" (click)="upgradeTier()">Upgrade tier</button> -->
        <div class="p-0 px-md-5 pt-md-5" id="widget-root"></div>
    </div>
    
</div>